import { motion } from 'framer-motion';
import { ShieldCheck, Clock3, MapPinned } from 'lucide-react';
import { TRUST } from '@/constants/testIds';

const BADGES = [
	{
		id: TRUST.badgeLicensed,
		icon: ShieldCheck,
		title: 'Licensed & Insured',
		note: 'Vetted operators in every service area',
	},
	{
		id: TRUST.badgeAvailability,
		icon: Clock3,
		title: '24 / 7 / 365',
		note: 'Answering the phone at 3 a.m. — always',
	},
	{
		id: TRUST.badgeCoverage,
		icon: MapPinned,
		title: 'Nationwide Coverage',
		note: 'Fifty states. Highways, rural roads, driveways.',
	},
];

export const TrustBadges = () => {
	return (
		<section
			data-testid={TRUST.root}
			className="bg-white border-t border-b border-brand-navy"
		>
			<div className="mx-auto max-w-[1400px] grid grid-cols-1 md:grid-cols-3">
				{BADGES.map((b, i) => (
					<motion.div
						key={b.id}
						data-testid={b.id}
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true, margin: '-80px' }}
						transition={{ duration: 0.6, delay: i * 0.08 }}
						className="flex items-center gap-5 p-6 sm:p-8 border-l border-brand-navy first:border-l-0 md:border-t-0 border-t md:first:border-t-0"
					>
						<div className="w-12 h-12 sm:w-14 sm:h-14 bg-brand-red text-white flex items-center justify-center flex-shrink-0">
							<b.icon className="w-6 h-6 sm:w-7 sm:h-7" strokeWidth={2} />
						</div>
						<div className="min-w-0">
							<div className="font-chivo font-black uppercase tracking-tight text-brand-navy text-base sm:text-lg leading-none">
								{b.title}
							</div>
							<div className="mt-1 font-plex text-xs sm:text-sm text-brand-navy/70">
								{b.note}
							</div>
						</div>
					</motion.div>
				))}
			</div>
		</section>
	);
};

export default TrustBadges;
